import { colors } from '@resume/ui/tokens'

/** 把 packages/ui 的 token 重新导出，方便 composition 用字面量 style 引用。 */
export const theme = colors
